module.exports = __webpack_public_path__ + "static/img/s75.595c6bd8.png";